import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';
import { AppModules } from '../appContainer/types';

export const routes = {
  path: '/asset-library',
  title: 'Asset library',
  appModule: AppModules.ASSET_LIBRARY,
  content: async (): PathRouteContent =>
    (await import('./AssetLibraryPage')).AssetLibraryPage,
  children: [],
} as const satisfies RouteNode;
